import Api from 'utils/Api'

class ScheduleRuleService {
  createSchedule(params) {
    return Api.call('/schedule-rule/create-schedule-rule', 'post', params, false, true)
    .then(res => res.data)
    .catch(err => {throw err})
  }

  getSchedulePackages(data) {
    return Api.call('/schedule-rule/avaiable-packages-for-hour', 'get', data)
    .then(res => res.data)
    .catch(err => { throw err; })
  }

  deleteScheduleRule(params) {
    return Api.call('/schedule-rule/delete-schedule-rule', 'post', params, false, true)
    .then(res => res.data)
    .catch(err => { throw err });
  }

  editScheduleRule(params) {
    return Api.call('/schedule-rule/update-schedule-rule', 'post', params, false, true)
    .then(res => res.data)
    .catch(err => { throw err });
  }
}

export default new ScheduleRuleService();


// WEBPACK FOOTER //
// ./src/services/ScheduleRuleService.js